 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		67: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		67: 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~media-gall~23d9e305","1":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~or~ddb78501","2":"add-to-list-drawer~bath-renovation~browse-and-search~browse-and-search-mobile~collections~collection~8f8db49f","3":"browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~orange-lens~paint-~0019270f","4":"buybox~promotion-products-lazy~quick-view","5":"buybox~stylequiz~super-sku","6":"media-gallery-filmstrip-mobile~media-gallery-overlay~media-gallery-overlay-mobile","7":"media-gallery-overlay~media-gallery-overlay-mobile~overlay","8":"media-gallery-overlay~media-gallery-overlay-mobile~stylequiz","9":"ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","10":"ratings-and-reviews~ratings-and-reviews-mobile~write-a-review-form","11":"add-to-list-drawer~magic-apron","12":"aisle-bay~buybox","13":"bath-renovation~orange-lens","14":"buybox~promotion-products-lazy","15":"compare~overlay","16":"ratings-and-reviews-mobile","17":"StoreLayout","18":"add-to-list-drawer","19":"aisle-bay","20":"augmented-reality","21":"bath-renovation","22":"breadcrumbs","23":"browse-and-search","24":"browse-and-search-mobile","25":"buybox","26":"calculator-pipcalculator","27":"collections","28":"collections-mobile","29":"common","30":"compare","31":"consumer-card-messaging","32":"customer-image-overlay","33":"drawer","34":"emt-generated-content","35":"emt-links","36":"emt-questions-and-answers-component","37":"fbr","38":"global-custom-configurator","39":"hammerjs","41":"home","42":"magic-apron","43":"measurement-guide","44":"measurement-guide-overlay-content","45":"media-gallery-filmstrip-mobile","46":"media-gallery-overlay","47":"media-gallery-overlay-mobile","48":"orange-lens","49":"order-sample","50":"order-sample-drawer","51":"overlay","52":"paint-reorder","53":"paint-reorder-mobile","54":"pep","55":"pep-mobile","56":"product","57":"product-mobile","58":"product-overview","59":"promotion-products-lazy","60":"question","61":"questions-and-answers","62":"quick-view","63":"ratings-and-reviews","64":"ratings-and-reviews-desktop","65":"results","66":"returns-messaging","68":"share-to-email-overlay","69":"share-to-pinterest-overlay","70":"size-guide-overlay","71":"specifications","72":"stylequiz","73":"super-sku","74":"vendor-collection-products","75":"vendor-collections","76":"vendor-collections-mobile","78":"video-player","79":"write-a-review-form"}[chunkId]||chunkId) + "." + {"0":"72c316804350afe72193","1":"a35e204f475de02d225b","2":"01b12a27c0ae4f2aae5e","3":"6b7e4e3131578857d7d1","4":"f62537bf9facc95b1dcd","5":"3d044d8400a0f8cfd4f6","6":"083e222b9e780b26253f","7":"ae3dd0d3e374ac6683bf","8":"23e17a2d09f185e6c3fe","9":"a69945436409e49b8457","10":"78c2d5c92cad33fd2a55","11":"7ff5bc499112c47c4eeb","12":"7f8d3652997a8d1572e5","13":"e2e7c6d4e69c53cb960a","14":"2f153c7755402ec7c79d","15":"5cc70661d2e5268a872a","16":"0959e4a0647c2e14a05b","17":"b0a6449853da09a8cbc5","18":"a1b372ca8aa0693e9568","19":"dda030f4b84fd984d4c8","20":"1a0390b107b42f9a2307","21":"f3fe9c0a093b66513850","22":"2b8e6b8b227f22c8c909","23":"c204c6f95f5b04b52cb4","24":"a832cfcab99db233bd88","25":"619b7ae54b0ba7a141dc","26":"d1f93a256fb638f236ab","27":"f3854b926eef15ef2229","28":"8b39d48701436ea2e3db","29":"4b7bb4e24d026f30843e","30":"3a8bdac21796661ebdb6","31":"44882d1f861b8c9dc137","32":"2d0c6b6e7d00fb3ef8f4","33":"32eb37c386a71ddfef15","34":"99cccfb6043c09a4882a","35":"1379f217d74bb6c54653","36":"cf524b8d8ddb4a8254cf","37":"06ccdb062f83e84e8349","38":"43fd73ed01645309e2e0","39":"81a134850ce14f6a1aa2","41":"95b30e871cf07056a51e","42":"f55a4fde210d0dac13a1","43":"3a6f64384aa32f979056","44":"b371344bee60617e1a25","45":"3d86d56050b899fb1998","46":"55c23c44584fcc240ae1","47":"e4692f36c8bbe0197773","48":"1004f1194b56507cde2e","49":"8c393d4f89730b54d1a7","50":"88f7b191f8932a9fbaca","51":"0718e9f1359ce801825d","52":"d3bfa981032869d22564","53":"04ed21706a8b90f4fac5","54":"267f36fd034eb139511c","55":"238b815b6de1f97def8a","56":"40121a159c03f14c23d8","57":"37cd59e9291effccd7aa","58":"3449e5223df408ecec71","59":"e60b30c2ae2f86b05da5","60":"88a7e4a3eb1fdc8e963c","61":"0c9ad8c8e78701d3df77","62":"27288449de07b4601f3e","63":"015a4bbe49ac37f86a1b","64":"803f2ea755e19530533e","65":"e7286b666935e348d64c","66":"7303fd877c757dbf5d67","68":"304b3ddfc6d0d2efd62b","69":"24f0f0ebe68badf736d8","70":"71163e13881c13e2ccc8","71":"949bb5c17cc58399f6b7","72":"be24815a4454b07d95e4","73":"d5278b5327728498d0e4","74":"acb411d0ee2af0a0f202","75":"3c1245bb634d82047bc4","76":"fc8301559c564d96b814","78":"7d65f61d5c20ca82a424","79":"4c0dea5a063b93407bfc"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1,"4":1,"5":1,"6":1,"7":1,"8":1,"9":1,"10":1,"15":1,"16":1,"19":1,"23":1,"24":1,"25":1,"27":1,"28":1,"30":1,"31":1,"32":1,"33":1,"34":1,"37":1,"38":1,"42":1,"45":1,"46":1,"47":1,"48":1,"51":1,"52":1,"53":1,"54":1,"55":1,"56":1,"57":1,"58":1,"59":1,"61":1,"62":1,"63":1,"70":1,"72":1,"73":1,"74":1,"75":1,"76":1,"78":1,"79":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~media-gall~23d9e305","1":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~or~ddb78501","2":"add-to-list-drawer~bath-renovation~browse-and-search~browse-and-search-mobile~collections~collection~8f8db49f","3":"browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~orange-lens~paint-~0019270f","4":"buybox~promotion-products-lazy~quick-view","5":"buybox~stylequiz~super-sku","6":"media-gallery-filmstrip-mobile~media-gallery-overlay~media-gallery-overlay-mobile","7":"media-gallery-overlay~media-gallery-overlay-mobile~overlay","8":"media-gallery-overlay~media-gallery-overlay-mobile~stylequiz","9":"ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","10":"ratings-and-reviews~ratings-and-reviews-mobile~write-a-review-form","11":"add-to-list-drawer~magic-apron","12":"aisle-bay~buybox","13":"bath-renovation~orange-lens","14":"buybox~promotion-products-lazy","15":"compare~overlay","16":"ratings-and-reviews-mobile","17":"StoreLayout","18":"add-to-list-drawer","19":"aisle-bay","20":"augmented-reality","21":"bath-renovation","22":"breadcrumbs","23":"browse-and-search","24":"browse-and-search-mobile","25":"buybox","26":"calculator-pipcalculator","27":"collections","28":"collections-mobile","29":"common","30":"compare","31":"consumer-card-messaging","32":"customer-image-overlay","33":"drawer","34":"emt-generated-content","35":"emt-links","36":"emt-questions-and-answers-component","37":"fbr","38":"global-custom-configurator","39":"hammerjs","41":"home","42":"magic-apron","43":"measurement-guide","44":"measurement-guide-overlay-content","45":"media-gallery-filmstrip-mobile","46":"media-gallery-overlay","47":"media-gallery-overlay-mobile","48":"orange-lens","49":"order-sample","50":"order-sample-drawer","51":"overlay","52":"paint-reorder","53":"paint-reorder-mobile","54":"pep","55":"pep-mobile","56":"product","57":"product-mobile","58":"product-overview","59":"promotion-products-lazy","60":"question","61":"questions-and-answers","62":"quick-view","63":"ratings-and-reviews","64":"ratings-and-reviews-desktop","65":"results","66":"returns-messaging","68":"share-to-email-overlay","69":"share-to-pinterest-overlay","70":"size-guide-overlay","71":"specifications","72":"stylequiz","73":"super-sku","74":"vendor-collection-products","75":"vendor-collections","76":"vendor-collections-mobile","78":"video-player","79":"write-a-review-form"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"2134e3f2525f4b18b82f","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"2687e814d6cb00bc5e5c","5":"20f2aced33e6b1ed7b41","6":"59d72f4e8c0806257828","7":"5a3833afc72235585445","8":"fc13927f2b1da7e66c1b","9":"50d430c72ccc3cf96a34","10":"65f1d7aedc445dc5836f","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"9f6e95f53122c35ea62a","16":"2ade42f7647d0b013747","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"d94b956aa532c1a50c65","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"ea3a45c584a377ed5442","24":"74f8c3391397401ef5c7","25":"2a89fc043b76a14cc5a3","26":"31d6cfe0d16ae931b73c","27":"34b44299451247e865ba","28":"8526f65c6b36d9fbe9b3","29":"31d6cfe0d16ae931b73c","30":"e1f63ff090d5f96e31b4","31":"b71f8ffaebe49e5b8650","32":"c466036523aec2558c34","33":"5521673608a60d69edf8","34":"b49004ddac99adec2224","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"88e24c7aafcf93ae6cc6","38":"1a5562a08d12f7682989","39":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"4be99b2862037eff2a09","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"e07956ac4ef9facbea2e","46":"dfc7b51b09c85048bcce","47":"c8b4a0f2dd48ef6c82a5","48":"89d9163eeb30e835d559","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"a2ad17b85a07c09310d6","52":"0374ea1c3d32f32ad050","53":"673f4ea21d73802c4485","54":"e09555f822bde67630b5","55":"59299efa60e6b5eea881","56":"64b1517991d42cf26fad","57":"f806dd05308a65f1d856","58":"be155bb5d11dacdc4bb8","59":"ee58265e369789fb3e9c","60":"31d6cfe0d16ae931b73c","61":"d70c859b20e57c1599c5","62":"fc2a9ff9eca0e4c41653","63":"9d02d79dc9b8f52f7762","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c","70":"453dfc2640779a848cc6","71":"31d6cfe0d16ae931b73c","72":"69a51d0e555e98d06a0d","73":"b31101625f385d3bcc30","74":"e518e335254638969e62","75":"dbf9caaeb7d1e10ebcd5","76":"069222bfb42459a097c9","78":"24ab350a8a93783bfec6","79":"231b01089814caaf9676"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.thdstatic.com/experiences/hd-home/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
